import React, { useState, useEffect } from 'react';

const LiveClock = ({ showSeconds = true, showDate = true, className = "" }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('es-MX', {
      hour: '2-digit',
      minute: '2-digit',
      second: showSeconds ? '2-digit' : undefined,
      hour12: true
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('es-MX', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getDayOfYear = (date) => {
    const start = new Date(date.getFullYear(), 0, 0);
    const diff = date - start;
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
  };

  const getWeekOfYear = (date) => {
    const start = new Date(date.getFullYear(), 0, 1);
    const days = Math.floor((date - start) / (24 * 60 * 60 * 1000));
    return Math.ceil((days + start.getDay() + 1) / 7);
  };

  return (
    <div className={`bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg p-4 shadow-lg ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="bg-white bg-opacity-20 rounded-full p-2">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <div className="text-2xl font-bold font-mono">
              {formatTime(currentTime)}
            </div>
            {showDate && (
              <div className="text-sm text-blue-100 capitalize">
                {formatDate(currentTime)}
              </div>
            )}
          </div>
        </div>
        
        <div className="text-right">
          <div className="text-sm text-blue-100">
            <div>Día {getDayOfYear(currentTime)} del año</div>
            <div>Semana {getWeekOfYear(currentTime)}</div>
          </div>
          <div className="text-xs text-blue-200 mt-1">
            Zona: {Intl.DateTimeFormat().resolvedOptions().timeZone}
          </div>
        </div>
      </div>
      
      {/* Barra de progreso del día */}
      <div className="mt-3">
        <div className="flex justify-between text-xs text-blue-100 mb-1">
          <span>Progreso del día</span>
          <span>{Math.round((currentTime.getHours() * 60 + currentTime.getMinutes()) / 14.4)}%</span>
        </div>
        <div className="w-full bg-white bg-opacity-20 rounded-full h-2">
          <div 
            className="bg-white bg-opacity-80 h-2 rounded-full transition-all duration-1000"
            style={{ 
              width: `${(currentTime.getHours() * 60 + currentTime.getMinutes()) / 14.4}%` 
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LiveClock;
